<div class="vendor-quotation-section">
    <div *ngIf="!isReadOnlyRFQSummary">
        <input #fileInput type="file" multiple hidden (change)="onFileSelected($event)">
        <app-button class="padBtn mar-r" icon="upload" name="Upload" (click)="fileInput.click()"></app-button>
    </div>
    <div *ngIf="dataSource.data.length > 0; else noDocuments">
        <table mat-table [dataSource]="dataSource" class="vendor-document-table">
            <!-- File Name Column -->
            <ng-container matColumnDef="FileName">
                <th mat-header-cell *matHeaderCellDef> File Name </th>
                <td mat-cell *matCellDef="let row" [ngClass]="{ 'strike-through': row.IsStrikethrough }"
                    [tp]="row.FileName" tpClassName="custom-tooltip" tpMaxWidth="300px" [tpInteractive]="true"
                    [tpIsEnabled]="row.FileName.length > 64" tpPlacement="bottom">
                    <span *ngIf="!row.IsNew && !row.IsStrikethrough" class="link" (click)="downloadVendorFile(row)">{{
                        row.FileName | truncateMiddle:56 }}</span>
                    <span *ngIf="row.IsNew ||  row.IsStrikethrough">{{
                        row.FileName| truncateMiddle:56 }}</span>
                </td>
            </ng-container>
            <!-- Purpose Column -->
            <ng-container matColumnDef="Purpose">
                <th mat-header-cell *matHeaderCellDef> Purpose </th>
                <td mat-cell *matCellDef="let row" [ngClass]="{ 'strike-through': row.IsStrikethrough }">
                    <ng-container *ngIf="isReadOnlyRFQSummary || row.IsStrikethrough ; else editablePurpose">
                        <span *ngIf="rfqAttachments && rfqAttachments.length > 0">
                            {{getPurpose( row.AttachmentTypeId )}}</span>
                    </ng-container>
                    <ng-template #editablePurpose>
                        <ng-select style="width: auto;" [items]="rfqAttachments" [(ngModel)]="row.AttachmentTypeId"
                            appearance="outline" bindLabel="Name" bindValue="Id" [appendTo]="'body'"
                            placeholder="Please select an option" (change)="checkVendorStatus()">
                        </ng-select>
                    </ng-template>
                </td>
            </ng-container>

            <!-- Uploaded By Column -->
            <ng-container matColumnDef="UploadedBy">
                <th mat-header-cell *matHeaderCellDef> Uploaded By </th>
                <td mat-cell *matCellDef="let row" [ngClass]="{ 'strike-through': row.IsStrikethrough }"
                    [tp]="row.CreatedBy" tpClassName="custom-tooltip" tpMaxWidth="300px" [tpInteractive]="true"
                    [tpIsEnabled]="row.CreatedBy.length > 64" tpPlacement="bottom">
                    {{getCreatedByUser( row.CreatedBy)}}
                </td>
            </ng-container>
            <!-- Action Column -->
            <ng-container matColumnDef="Action" stickyEnd>
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let row;">
                    <button mat-icon-button (click)="!row.IsStrikethrough && removeDocument(row)"
                        [disabled]="row.IsStrikethrough">
                        <img src="/assets/images/remove_circle_outline.svg" alt="Remove" class="delete-icon">
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
    <ng-template #noDocuments>
        <p class="no-document-received">No documents received</p>
    </ng-template>
</div>